import { safeDefineElement } from '@/scripts/core/global'
import { ProductModal } from '@/scripts/product/product-modal'
import { MediaGallery } from '@/scripts/product/media-gallery'
import { ProductRecommendations } from '@/scripts/theme/product-recommendations';
import {ProductTabs} from "@/scripts/product/product-tabs";
import {ProductStickyCta} from "@/scripts/product/product-sticky-cta";
import {GcmsData} from "@/scripts/product/gcms-data";
import {WishlistButton} from "@/scripts/product/wishlist-button";
import { BundleComponent } from '@/scripts/bundle';

safeDefineElement(ProductModal)
safeDefineElement(MediaGallery)
safeDefineElement(ProductRecommendations)
safeDefineElement(ProductTabs)
safeDefineElement(ProductStickyCta)
safeDefineElement(GcmsData)
safeDefineElement(WishlistButton)
safeDefineElement(BundleComponent)
